// @ts-expect-error Untyped import
import { EVENTS } from '../../../lib/usageTracker';
// @ts-expect-error Untyped import
import { trackEvent } from '../../../lib/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const trackViewPermissionDeniedProblem = () => {
  trackEvent(EVENTS.viewPermissionDeniedTooltip, {
    actionType: 'share',
    assetType: 'report',
    interactionWith: 'navigation links',
    interactionSource: 'ReportsTableRow'
  });
};
export const PrivateReportLink = ({
  TooltipMessage
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: TooltipMessage ? /*#__PURE__*/_jsx(TooltipMessage, {}) : null,
  children: /*#__PURE__*/_jsx(Link, {
    disabled: true,
    children: /*#__PURE__*/_jsx("div", {
      "data-test-id": "report-row-name-disabled",
      onMouseEnter: () => trackViewPermissionDeniedProblem(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'reports.permissions.privateReport'
      })
    })
  })
});